import React from 'react';
import PropTypes from 'prop-types';
import styles from './resources.css';

const Resources = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {data.map(item => (
          <li className={styles.listItem} key={item.title}>
            <a className={styles.link} href={item.url}>
              <span>{item.title}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

Resources.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Resources;
